<template>
    <div>
        <el-card class="box-card">

            <div slot="header" class="clearfix">
                <span>停车牌信息</span>
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">

                <el-form-item label="名字" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model.number="ruleForm.phone"></el-input>
                </el-form-item>

            </el-form>
        </el-card>

        <el-card class="box-card">

            <div slot="header" class="clearfix">
                <span>客户信息</span>
            </div>

            <el-form :model="uploadRuleForm" :rules="rules" ref="uploadRuleForm" label-width="80px" class="demo-ruleForm">

                <el-form-item label="旺旺名称" prop="WangWangID" >
                    <el-input v-model="uploadRuleForm.WangWangID"></el-input>
                </el-form-item>

                <el-form-item label="输出"  prop="desc" v-if="~this.ruleForm.name.indexOf('#test')">
                    <el-input type="textarea" autosize :value="vcardContent"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-popover
                ref="popover5"
                placement="bottom"
                width="250"
                v-model="createVisible">
                <p>请确认信息:</p>
                <p>姓名:
                    <span class="highlight-text">
                    {{this.ruleForm.name}}
                    </span>
                    </p>
                <p>电话:
                    <span class="highlight-text">

                    {{this.ruleForm.phone}}
                    </span>
                    </p>
                <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="createVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')"  :loading="loadingBtn">提交</el-button>
                </div>
                </el-popover>

                <el-button type="primary" v-popover:popover5 :disabled="this.disabledBtn">立即创建</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
            
        </el-card>
    </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      createVisible: false,
      loadingBtn:false,
      disabledBtn:true,
      ruleForm: {
        name: "",
        phone: "",
        WangWangID: "",
        desc: ""
      },
      uploadRuleForm: {
        WangWangID: ""
      },
      rules: {
        name: [{ required: true, message: "请输入你的名字", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入你的联系方式", trigger: "blur" },
          //   { min: 5, max: 11, message: '手机号为11位', trigger: 'blur' },
          { type: "number", message: "手机号必须为数字" }
        ],
        WangWangID: [
          { required: true, message: "请填入你淘宝的账号名", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    vcardContent() {
      let template = `BEGIN:VCARD
FN:${this.$data.ruleForm.name}
TEL;VOICE:${this.$data.ruleForm.phone}（轻按可呼叫）
END:VCARD`;
      return template;
    },

  },
  watch:{
      ruleForm:{
          handler(){
          this.isWriteDone();
        },
        deep:true
      },
      uploadRuleForm:{
          handler(){
          this.isWriteDone();
          },
          deep:true
      }
  },

  methods: {
    isWriteDone(){
            let flag1=false,flag2=false;
            console.log(this.$data);

            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    flag1=true;
                }
            });
            this.$refs["uploadRuleForm"].validate(valid => {
                if (valid) {
                    flag2=true;
                }
            });
            this.disabledBtn=!(flag1&&flag2);
            return !(flag1&&flag2);
      },      
    submitForm() {
      let params = {
        vcardContent: this.vcardContent,
        WangWangID: this.uploadRuleForm.WangWangID
      };
      this.loadingBtn=true;
      axios.post("/api/uploadVcard", params).then((res)=>{
          console.log(res);
          if(res.data==="ok"){
              this.$alert('请与客服确认', '上传成功', {
                type: 'success',
                confirmButtonText: '好的',
                callback: action => {
                    this.$message({
                    type: 'success',
                    message: `谢谢惠顾`
                    });
                }
                });

          }else{
              this.$alert('很抱歉碰到了这个问题,请您刷新网页后重试', '上传失败', {
                type: 'error',
                confirmButtonText: '好的',
                });

          }
            this.loadingBtn=false;
            this.createVisible = false;
            // this.resetForm("ruleForm");
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
};
</script>

<style>
.highlight-text {
  color: #f56c6c;
}
.box-card{
    margin: 3em 1em;
}
.el-message-box{
    width: 80%!important;
    max-width: 500px!important;
}
</style>


// WEBPACK FOOTER //
// src/views/Vcard.vue